import gql from 'graphql-tag'

const query = gql`
query getDepartment($id: ID!) {
	cashAssist {
		getDepartment(id: $id) {
			id
	    mod_ver
	    name
	  }
	}
}
`
export default query
